import { Metric } from 'web-vitals';

type ReportHandler = (metric: Metric) => void;

const reportWebVitals = (onPerfEntry?: ReportHandler) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then((webVitals: any) => {
      /**
       * Provides functions to measure and report key web performance metrics:
       * - Cumulative Layout Shift (CLS)
       * - First Input Delay (FID)
       * - First Contentful Paint (FCP)
       * - Largest Contentful Paint (LCP)
       * - Time to First Byte (TTFB)
       *
       * These metrics help analyze real-world performance on various critical aspects
       * of the user experience. Use each function to retrieve individual metrics as
       * users interact with the page.
       */
      const { getCLS, getFID, getFCP, getLCP, getTTFB } = webVitals;
      getCLS(onPerfEntry);
      getFID(onPerfEntry);
      getFCP(onPerfEntry);
      getLCP(onPerfEntry);
      getTTFB(onPerfEntry);
    });
  }
};

export default reportWebVitals;
